import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_freshbites-scale/artifacts/1dmgcnkh_WhatsApp%20Image%202026-01-09%20at%2016.12.17.jpeg" 
              alt="Fresh Bites Group Ltd" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm mb-4">
              Manufacturing authentic traditional recipes into scalable, healthy commercial products.
            </p>
            <p className="text-gray-500 text-xs">
              Fresh Bites Group Ltd<br />
              Company No: 15757659
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-emerald-400">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">About Us</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">Services</Link></li>
              <li><Link to="/how-we-work" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">How We Work</Link></li>
              <li><Link to="/partners" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">Partners</Link></li>
              <li><Link to="/careers" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">Careers</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-emerald-400">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <MapPin size={18} className="flex-shrink-0 mt-1 text-emerald-400" />
                <span>Kitchen 4, Griller Kitchens, 121 Miller St, Birmingham B6 4NG</span>
              </li>
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <MapPin size={18} className="flex-shrink-0 mt-1 text-emerald-400" />
                <span>706 Canterbury House, Birmingham B31DB</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <Mail size={18} className="text-emerald-400" />
                <a href="mailto:are@freshbitesgroup.com" className="hover:text-emerald-400 transition-colors duration-300">
                  are@freshbitesgroup.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <Phone size={18} className="text-emerald-400" />
                <span>+44 7769476968</span>
              </li>
            </ul>
          </div>

          {/* Social & Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-emerald-400">Follow Us</h3>
            <div className="flex gap-4 mb-6">
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                <Facebook size={24} />
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                <Twitter size={24} />
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                <Linkedin size={24} />
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                <Instagram size={24} />
              </a>
            </div>
            <h4 className="text-sm font-semibold mb-2 text-emerald-400">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300 text-sm">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300 text-sm">Terms of Service</Link></li>
              <li><Link to="/food-safety" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300 text-sm">Food Safety Standards</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6">
          <p className="text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} Fresh Bites Group Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
